import KendoSchedulerDataSourceMixin from './KendoSchedulerDataSourceMixin'

export default {
    name: 'kendo-schedulerdatasource',
    mixins: [ KendoSchedulerDataSourceMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoSchedulerDataSource/index.js